<template>
  <div class="content">
    <div class="home-container">
      <h3 class="text-center">ИМЖ ЦАХИМ БОДЛОГЫН САН</h3>
      <carousel
        class="carousel row my-5"
        :per-page="4"
        :perPageCustom="[
          [300, 1],
          [900, 2],
          [1300, 3],
          [1599, 4],
        ]"
        :mouse-drag="true"
        :autoplay="true"
        paginationColor="#ffffff"
        :paginationSize="15"
      >
        <slide v-for="(home, index) in homePage" :key="index.home">
          <div class="slide">
            <div class="image-carousel-content">
              <div
                :class="{
                  image1: index === 0,
                  image2: index === 1,
                  image3: index === 2,
                  image4: index === 3,
                  image5: index === 4,
                }"
              >
                <div class="image-carousel"></div>
              </div>
            </div>
            <div class="carousel-text">
              <span class="carousel-text-in"> {{ home.text }} </span>
            </div>
          </div>
        </slide>
      </carousel>
    </div>

    <span class="register-link" v-if="!loggedIn">
      ИЛҮҮ ИХ БОЛОМЖИЙГ АВАХЫГ ХҮСВЭЛ
      <b-link to="Registration">ЭНД</b-link>ДАРЖ БҮРТГҮҮЛЭЭРЭЙ
    </span>
    <ClassifyCom />
  </div>
</template>
<script>
import user from "../mixins/user.js";
import ClassifyCom from "../components/ClassifyCom.vue";

export default {
  mixins: [user],
  data() {
    return {
      homePage: [
        { text: "Хүүхэд бүр өөрийн хурдаар суралцах боломж " },
        { text: "Бодолт харах боломжтой" },
        { text: "Математик сэтгэхүй хөгжүүлнэ" },
        { text: "Асуудлыг математик аргаар шийдвэрлэхэд суралцана" },
      ],
    };
  },
  components: {
    ClassifyCom,
  },
};
</script>
<style lang="postcss" scoped>
.home-container {
  padding: 50px;
  font-family: "Roboto", sans-serif;
  max-width: 95%;
  margin-right: auto;
  margin-left: auto;
}
h3 {
  color: #22b353;
  font-size: 2.188em;
  font-weight: 400;
}
.slide {
  background-color: #ffff;
  border-radius: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95%;
  max-width: 355px;
  height: 100%;
  padding: 15px;
}
.carousel {
  margin-right: auto;
  margin-left: auto;
  width: 92%;
}
@media screen and (max-width: 800px) {
  .slide {
    width: 100%;
  }
  .carousel {
    width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
}
.image1 {
  background: url("../assets/images/home-image1.png");
  background-repeat: no-repeat;
  width: 216px;
  height: 211px;
}
.image2 {
  background: url("../assets/images/home-image2.png");
  background-repeat: no-repeat;
  width: 216px;
  height: 211px;
}
.image3 {
  background: url("../assets/images/home-image3.png");
  background-repeat: no-repeat;
  width: 246px;
  height: 211px;
}
.image4 {
  background: url("../assets/images/home-image4.png");
  background-repeat: no-repeat;
  width: 216px;
  height: 211px;
}
.image5 {
  background: url("../assets/images/home-image4.png");
  background-repeat: no-repeat;
  width: 216px;
  height: 211px;
}

.image-carousel {
  border-radius: 50%;
}

.register-link {
  background-color: #22b353;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3em;
  color: #ffffff;
  padding: 20px;
}

@media screen and (max-width: 800px) {
  .register-link {
    font-size: 18px;
  }
}
@media screen and (max-width: 700px) {
  .register-link {
    font-size: 16px;
  }
}
@media screen and (max-width: 600px) {
  .register-link {
    font-size: 13px;
  }
}
@media screen and (max-width: 500px) {
  .register-link {
    font-size: 10px;
  }
}
@media screen and (max-width: 400px) {
  .register-link {
    font-size: 7px;
  }
}
.register-link a {
  color: #000000;
  border: none;
  border-radius: 5px;
  margin: 0px 5px 0px 5px;
  padding: 0px 5px 0px 5px;
  background-color: #f39317;
}
.register-link a:hover {
  text-decoration: none;
}
.carousel-text {
  font-size: 1.4375em;
  text-align: center;
}
.mb-5,
.my-5 {
  margin-bottom: 0rem !important;
}
.carousel-text {
  max-width: 268px;
}
</style>
